import type { RawMaterial } from '@buying/library';

import { randProductMaterial, randUuid } from '@ngneat/falso';

export const mockRawMaterial = (
    overwrite?: Partial<RawMaterial>
): RawMaterial => ({
    rawMaterialPublicId: randUuid(),
    rawMaterialName: randProductMaterial(),
    isDeleted: false,
    ...overwrite,
});
